import { Storage } from "../../lib/data/Storage.js";

export class AppStorage extends Storage {

}
